// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipment{position:relative}.customs-notification{position:fixed;bottom:22px;transform:translateX(52%)}@media(max-width:1535px){.customs-notification{left:52%;transform:translateX(-50%)}}@media(max-width:599px){.customs-notification{left:20px;right:20px;transform:translateX(0)}}", ""]);
// Exports
module.exports = exports;
